import Clipboard from "@stimulus-components/clipboard"

import { copyText } from "@/lib/clipboard"

// Extends the stock controller with the shared secure/insecure-context
// copy helper (see lib/clipboard) so plain-HTTP dev setups and the
// Docker Selenium grid keep working.
export default class extends Clipboard {
  copy(event: Event) {
    event.preventDefault()

    const source = this.sourceTarget
    void copyText(source.innerHTML || source.value).then(() => this.copied())
  }
}
